import React from 'react';
import SplitViewFieldsGrid from '../../../../components/generic/SplitViewFieldsGrid';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { ApprovalIntegration } from '../../../../components/generic';
import { nonConformityReportConfig } from '../../nonConformityReportConfig';

const NonConformityReportDetailsTab = ({ 
  selectedRecord, 
  selectedRecordFiles, 
  config, 
  fields 
}) => {
  const { theme } = useTheme();

  return (
    <div 
      className="p-4 flex-1 overflow-y-auto advanced-table-scroll"
      style={{ 
        scrollbarWidth: 'thin',
        minHeight: 0,
        maxHeight: '100%'
      }}
    >
      <div className="grid grid-cols-1 gap-4">
        {/* Non-Conformity Report Review and Approval Integration - Moved to top */}
        {nonConformityReportConfig.shouldShowApprovalInDetails() && (
          <div className="mb-6">
            <ApprovalIntegration 
              entity={selectedRecord}
              entityType="non_conformity_report"
              entityData={{
                ncrCode: selectedRecord.code,
                ncrTitle: selectedRecord.title,
                nonConformityType: selectedRecord.nonConformityType?.name,
                department: selectedRecord.department?.name,
                status: selectedRecord.status?.name,
                priority: selectedRecord.priority?.name,
                severity: selectedRecord.severity,
                detectedBy: selectedRecord.detectedBy?.userDisplayName,
                detectedAt: selectedRecord.detectedAt,
                description: selectedRecord.description,
                rootCause: selectedRecord.rootCause,
                createdBy: selectedRecord.createdBy?.userDisplayName,
                createdAt: selectedRecord.createdAt
              }}
              onApprovalUpdate={(approval) => {
                console.log('Review and approval updated:', approval);
                // You can add additional logic here to refresh the non-conformity report data
              }}
              customTitle="Non-Conformity Report Review and Approval Status"
              customButtonText={nonConformityReportConfig.approval.approvalButtonText}
              showEntityDetails={nonConformityReportConfig.approval.showApprovalStatus}
              showApprovalActions={nonConformityReportConfig.approval.showApprovalActions}
              showApprovalHistory={nonConformityReportConfig.approval.showApprovalHistory}
              formMode={nonConformityReportConfig.approval.formMode || 'standalone'}
              config={{
                defaultApprovalType: nonConformityReportConfig.approval.defaultApprovalType,
                allowMultipleApprovals: nonConformityReportConfig.approval.allowMultipleApprovals
              }}
            />
          </div>
        )}
                <SplitViewFieldsGrid
          selectedRecord={selectedRecord}
          fields={fields}
          config={config}
          layout="plain"
        />
        
        {/* File Attachments Section */}
        {selectedRecordFiles && selectedRecordFiles.length > 0 && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-base" aria-hidden="true">📎</span>
              <div className={cn("text-sm font-semibold", theme.text.primary)}>File Attachments</div>
            </div>
            <div className="grid grid-cols-1 gap-2">
              {selectedRecordFiles.map((file, idx) => (
                <div key={idx} className={cn(
                  "flex items-center justify-between p-2 rounded border",
                  theme.border.subtle,
                  theme.colors.background
                )}>
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span className={cn("text-sm", theme.text.primary)}>{file.originalName}</span>
                  </div>
                  <div className={cn("text-xs", theme.text.muted)}>
                    {(file.fileSize / 1024).toFixed(1)} KB
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NonConformityReportDetailsTab;
